import { useGetAssessmentProgresses } from "@/api/console/assessment-progresses/useGetAssessmentProgresses";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import Select from "@/components/Select";
import { InputWithIcon } from "@/components/ui/input";
import useStatuses from "@/hooks/useStatuses";
import SubmissionTable from "@/src/console/(auth)/(check-assessments)/all-assessments/_components/SubmissionTable";
import { BuildingRegular } from "@fluentui/react-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function AllAssessments() {
  const { t } = useTranslation();
  const { statuses } = useStatuses();
  const filters = [
    {
      label: t("all-progress"),
      value: "0",
    },
    ...statuses.map((status) => ({
      label: status.name,
      value: `${status.id}`,
    })),
  ];

  const [filter, setFilter] = useState(filters[0].value);
  const [search, setSearch] = useState("");

  const breadcrumbs = [
    {
      name: t("all-assessments"),
      href: "/console/all-assessments",
    },
  ];

  const { data, isLoading } = useGetAssessmentProgresses();
  const submissions = data?.data ?? [];

  const searchedSubmissions = submissions.filter((submission) =>
    (submission.company_name ?? "")
      .toLowerCase()
      .includes(search.toLowerCase()),
  );
  const filteredSubmissions = searchedSubmissions.filter((submission) => {
    if (filter == "0") return true;
    return `${submission.status.id}` === filter;
  });

  return (
    <div className="flex h-full grow flex-col">
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <div>
        <div className="bg-white shadow">
          <div className="my-heading px-6 pt-8">{t("all-assessments")}</div>
          <div className="flex justify-between px-6 pb-6 pt-8">
            <Select
              className="rounded-lg border shadow"
              width="260px"
              options={filters}
              value={filter}
              onChange={setFilter}
            />
            <InputWithIcon
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              Icon={BuildingRegular}
              placeholder="Search"
            />
          </div>
        </div>
        <div className="mx-6 my-6">
          <SubmissionTable isLoading={isLoading} data={filteredSubmissions} />
        </div>
      </div>
    </div>
  );
}

export default AllAssessments;
